import "./Home.css";
import { useEffect, useState } from "react";
import { Card } from "../../Components/Card/Card";
import RecentCard from "../../Components/RecentCard/RecentCard";
import { init } from "@fullstory/browser";
import { useNavigate } from "react-router-dom";
import { search } from "../../Utils/functions";
import { useContext } from "react";
import { FilterContext } from "../../Context/FilterContext";
import UpgradeSubscriptionModal from "../../Components/UpgradeSubscriptionModal/UpgradeSubscriptionModal";

init({ orgId: "o-200RRF-na1" });

function Home() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  const { filters } = useContext(FilterContext);

  const handleSearchAndNavigate = async (question, searchMode) => {
    try {
      const result = await search(question, filters, {}, "", searchMode);

      if (result.error) {
        setErrorMessage(result.error);
        return;
      }

      if (result.id) {
        navigate(`/search/${result.id}`);
      }
    } catch (error) {
      console.error("Error during search:", error);
      setErrorMessage("An unexpected error occurred. Please try again.");
    }
  };

  const closeErrorModal = () => {
    setErrorMessage(null);
  };

  return (
    <div className="Home">
      <Card search={handleSearchAndNavigate} />
      <RecentCard search={handleSearchAndNavigate} />
      {errorMessage && (
        <UpgradeSubscriptionModal
          message={errorMessage}
          onClose={closeErrorModal}
        />
      )}
    </div>
  );
}

export default Home;
